import {RouterModule, Routes} from '@angular/router';

import {LoginComponent} from './auth/login/login.component';
import {AdminComponent} from './layout/admin/admin.component';
import {isLoggedInResolver} from './routing/is-logged-in.resolve';
import {DashboardBackOfficeComponent} from './back-office/Components/dashboard/dashboard-back-office.component';
import {DashboardComponent} from './dealer-system/Components/dashboard/dashboard.component';
import {LocalizationOverviewComponent} from './back-office/Components/localization/localization-overview/localization-overview.component';
import {LanguageListComponent} from './back-office/Components/localization/language-list/language-list.component';
import {LocalizationLabelComponent} from './back-office/Components/localization/localization-label/localization-label.component';
import {ManageEmailComponent} from './back-office/Components/email-component/manage-email/manage-email.component';
import {EmailOverviewComponent} from './back-office/Components/email-component/email-overview/email-overview.component';
import {EmailLogComponent} from './back-office/Components/email-component/email-log/email-log.component';
import {SystemUsersOverviewComponent} from './back-office/Components/system-users/system-users-overview/system-users-overview.component';
import {ManageSystemUsersComponent} from './back-office/Components/system-users/manage-system-users/manage-system-users.component';
import {ManageCollectionComponent} from './back-office/Components/collection/manage-collection/manage-collection.component';
import {CollectionOverviewComponent} from './back-office/Components/collection/collection-overview/collection-overview.component';
import {ManageProductComponent} from './back-office/Components/product/manage-product/manage-product.component';
import {ModelOverviewComponent} from './back-office/Components/model/modal-overview/model-overview.component';
import {ManageModelComponent} from './back-office/Components/model/manage-model/manage-model.component';
import {ProductOverviewComponent} from './back-office/Components/product/product-overview/product-overview.component';
import {ViewCollectionComponent} from './back-office/Components/collection/view-collection/view-collection.component';
import {ViewModelComponent} from './back-office/Components/model/view-model/view-model.component';
import {ForgetPasswordComponent} from './auth/forget-password/forget-password.component';
import {SuccessForgetPasswordComponent} from './auth/success-forget-password/success-forget-password.component';
import {isNotLoggedInResolver} from './routing/is-not-logged-in.resolve';
import {DealerOverviewComponent} from './back-office/Components/dealer/dealer-overview/dealer-overview.component';
import {ResetPasswordComponent} from './auth/reset-password/reset-password.component';
import {resetPasswordResolver} from './routing/resetpassword.resolve';
import {ManageOrderComponent} from './shared/order/manage-order/manage-order.component';
import {isAccessDealerResolver} from './routing/is-access-dealer.resolve';
import {SuccessOrderComponent} from './dealer-system/Components/success-order/success-order.component';
import {translationResolver} from './routing/translation.resolve';
import {isAccessBackOfficeResolver} from './routing/is-access-back-office.resolve';
import {canDeactivateGuard} from './shared/components/can-deactivate/can-deactivate.guard';
import {PropertyOverviewComponent} from './back-office/Components/property/property-overview/property-overview.component';
import {ManagePropertyComponent} from './back-office/Components/property/manage-property/manage-property.component';
import {FabricCollectionComponent} from './back-office/Components/fabric-collection/fabric-collection-overview/fabric-collection.component';
import {
  ManageFabricCollectionComponent
} from './back-office/Components/fabric-collection/manage-fabric-collection/manage-fabric-collection.component';
import {FabricViewComponent} from './back-office/Components/fabric/fabric-view/fabric-view.component';
import {
  ViewFabricCollectionComponent
} from './back-office/Components/fabric-collection/view-fabric-collection/view-fabric-collection.component';
import {ManageFabricComponent} from './back-office/Components/fabric/manage-fabric/manage-fabric.component';
import {SupplierOverviewComponent} from './back-office/Components/supplier/supplier-overview/supplier-overview.component';
import {ManageSupplierComponent} from './back-office/Components/supplier/manage-supplier/manage-supplier.component';
import {ViewSupplierComponent} from './back-office/Components/supplier/view-supplier/view-supplier.component';
import {ArchiveSupplierViewComponent} from './back-office/Components/supplier/archive-supplier-view/archive-supplier-view.component';
import {ArchivePropertyViewComponent} from './back-office/Components/property/archive-property-view/archive-property-view.component';
import {
  ArchiveFabricCollectionViewComponent
} from './back-office/Components/fabric-collection/archive-fabric-collection-view/archive-fabric-collection-view.component';
import {
  ArchiveCollectionViewComponent
} from './back-office/Components/collection/archive-collection-view/archive-collection-view.component';

import {ManageOptionComponent} from './back-office/Components/option/manage-option/manage-option.component';
import {OptionOverviewComponent} from './back-office/Components/option/option-overview/option-overview.component';
import {ViewOptionComponent} from './back-office/Components/option/view-option/view-option.component';
import {ArchiveModelViewComponent} from './back-office/Components/model/archive-model-view/archive-model-view.component';
import {ArchiveOptionViewComponent} from './back-office/Components/option/archive-option-view/archive-option-view.component';
import {ArchiveProductViewComponent} from './back-office/Components/product/archive-product-view/archive-product-view.component';
import {ManageLanguageComponent} from './back-office/Components/localization/manage-language/manage-language.component';
import {ViewProductComponent} from './back-office/Components/product/view-product/view-product.component';
import {OrderOverviewComponent} from './dealer-system/Components/order/order-overview/order-overview.component';
import {QuoteOverviewComponent} from './dealer-system/Components/quote/quote-overview/quote-overview.component';

import {ViewBillingAccountComponent} from './back-office/Components/dealer/view-billing-account/view-billing-account.component';
import {backBreadCrumbResolver} from './routing/back-bread-crumb.resolve';
import {DownloadOverviewComponent} from './back-office/Components/download/download-overview/download-overview.component';
import {ManageDownloadComponent} from './back-office/Components/download/manage-download/manage-download.component';
import {DownloadsOverviewComponent} from './dealer-system/Components/download/downloads-overview/downloads-overview.component';
import {AccountOverviewComponent} from './dealer-system/Components/account/account-overview/account-overview.component';
import {InvoiceComponent} from './dealer-system/Components/invoice/invoice.component';
import {CountryOverviewComponent} from './back-office/Components/country/country-overview/country-overview.component';
import {ManageCountryComponent} from './back-office/Components/country/manage-country/manage-country.component';
import {BackofficeViewOrderComponent} from './back-office/Components/order/backoffice-view-order/backoffice-view-order.component';
import {BackofficeOrderOverviewComponent} from './back-office/Components/order/order-overview/backoffice-order-overview.component';
import {BackofficePosRegistrationOverviewComponent} from './back-office/Components/order/pos-registration-overview/backoffice-pos-registration-overview.component';
import {ManageDeliveryDealerComponent} from './back-office/Components/dealer/manage-delivery-dealer/manage-delivery-dealer.component';
import {ViewDeliveryDealerComponent} from './back-office/Components/dealer/view-delivery-dealer/view-delivery-dealer.component';
import {
  BackofficeInvoiceOverviewComponent
} from './back-office/Components/invoice/backoffice-invoice-overview/backoffice-invoice-overview.component';
import {ExportComponent} from './back-office/Components/export/export.component';
import {ManageDealerPointsComponent} from './back-office/Components/dealer-points/manage-dealer-points/manage-dealer-points.component';
import {GeneralTermsOverviewComponent} from './back-office/Components/general-terms/general-term-overview/general-terms-overview.component';
import {ManageGeneralTermComponent} from './back-office/Components/general-terms/manage-general-term/manage-general-term.component';
import {
  CreditInvoiceOverviewComponent
} from './back-office/Components/credit-invoice/credit-invoice-overview/credit-invoice-overview.component';
import {AcceptTermComponent} from './auth/accept-term/accept-term.component';
import {acceptTermsResolver} from './routing/accept-terms.resolve';
import {ManageStyleComponent} from './back-office/Components/style/manage-style/manage-style.component';
import {StyleOverviewComponent} from './back-office/Components/style/style-overview/style-overview.component';
import {StockProductComponent} from './back-office/Components/product/stock-product/stock-product.component';
import {ArchiveStyleViewComponent} from './back-office/Components/style/archive-style-view/archive-style-view.component';
import {ArchiveStockProductComponent} from './back-office/Components/product/archive-stock-product/archive-stock-product.component';
import {PackagingLabelComponent} from './back-office/Components/packaging-label/packaging-label.component';
import {
  DealerDashboardOverviewComponent
} from './back-office/Components/dealer-dashboard/dealer-dashboard-overview/dealer-dashboard-overview.component';
import {
  ArchiveDealerDashboardComponent
} from './back-office/Components/dealer-dashboard/archive-dealer-dashboard/archive-dealer-dashboard.component';
import {ManageBlockComponent} from './back-office/Components/dealer-dashboard/manage-block/manage-block.component';
import {
  InvoiceLayoutOverviewComponent
} from './back-office/Components/invoice-layout/invoice-layout-overview/invoice-layout-overview.component';
import {ManageInvoiceLayoutComponent} from './back-office/Components/invoice-layout/manage-invoice-layout/manage-invoice-layout.component';
import {
  DealerProfileOverviewComponent
} from './back-office/Components/dealer-profile/dealer-profile-overview/dealer-profile-overview.component';
import {ExactLogsOverviewComponent} from './back-office/Components/exact-logs/exact-logs-overview/exact-logs-overview.component';
import {ExchangeLogsOverviewComponent} from './back-office/Components/exchange-logs/exchange-logs-overview/exchange-logs-overview.component';
import {ManageDealerProfileComponent} from './back-office/Components/dealer-profile/manage-dealer-profile/manage-dealer-profile.component';
import {ManageTokenComponent} from './back-office/Components/exact/manage-token/manage-token.component';
import {onHoldResolver} from './routing/on-hold.resolve';
import {
  ExactCrmUpdatesOverviewComponent
} from './back-office/Components/exact-logs/exact-crm-updates-overview/exact-crm-updates-overview.component';
import { tabletUserDataModifierGuard } from './routing/tablet-user-data-modifier.guard';
import { superAdminGuard } from './routing/super-admin.guard';
import { VerifyCodeComponent } from './auth/verify-code/verify-code.component';
import { AccountSettingComponent } from './back-office/Components/account-setting/account-setting.component';
import { backofficeGuard } from './routing/backoffice.guard';
import {ExactRetriesOverviewComponent} from './back-office/Components/exact-logs/exact-retries-overview/exact-retries-overview.component';
import {ManageDisclaimerComponent} from './back-office/Components/disclaimer/manage-disclaimer/manage-disclaimer.component';
import {DisclaimerOverviewComponent} from './back-office/Components/disclaimer/disclaimer-overview.component';
import {InternalPackagingLabelComponent} from './back-office/Components/internal-packaging-label/internal-packaging-label.component';
import {ArchiveDealerViewComponent} from './back-office/Components/dealer/archive-dealer-view/archive-dealer-view.component';
import {
  BillingAccountsOverviewComponent
} from './back-office/Components/dealer/billing-accounts-overview/billing-accounts-overview.component';
import {ViewDealerComponent} from './back-office/Components/dealer/view-dealer/view-dealer.component';
import {WorkFormItemOverviewComponent} from './back-office/Components/work-form-item/work-form-item-overview.component';
import {ManageWorkFormItemComponent} from './back-office/Components/work-form-item/manage-work-form-item/manage-work-form-item.component';
import { TmsLogComponent } from './back-office/Components/product/tms-log/tms-log.component';
import { NgModule } from '@angular/core';
import { ViewOrderComponent } from './dealer-system/Components/order/view-order/view-order.component';
import { ManageServiceRemarkComponent } from './shared/service-remark/manage-service-remark/manage-service-remark.component';
import { ManageServiceRequestComponent } from './shared/service-request/manage-service-request/manage-service-request.component';
import {ManagePartsComponent} from './back-office/Components/parts/manage-parts/manage-parts.component';
import {ArchivePartsViewComponent} from './back-office/Components/parts/archive-parts-view/archive-parts-view.component';
import {PartsOverviewComponent} from './back-office/Components/parts/parts-overview/parts-overview.component';
import { BackofficeOverviewQuoteComponent } from './back-office/Components/quote/quote-overview/quote-overview.component';
import { BackofficeViewQuoteComponent } from './back-office/Components/quote/view-quote/view-quote.component';
import {BackofficeDrafyInvoiceOverviewComponent} from './back-office/Components/invoice draft/backoffice-draft-invoice-overview/backoffice-draft-invoice-overview.component';
import {BackofficeDraftInvoiceViewComponent} from './back-office/Components/invoice draft/backoffice-draft-invoice-view/backoffice-draft-invoice-view.component';
import { DraftInvoiceLogsOverviewComponent } from './back-office/Components/draft-invoice-logs/draft-invoice-logs-overview/draft-invoice-logs-overview.component';
import {
  ServiceRequestOverviewComponent
} from './back-office/Components/service-request/service-request-overview/service-request-overview.component';
import {
  DealerServiceRequestOverviewComponent
} from './dealer-system/Components/service/service-request-overview/service-request-overview.component';
import {ViewServiceRequestComponent} from './back-office/Components/service-request/view-service-request/view-service-request.component';
import {
  ServiceSubjectOverviewComponent
} from './back-office/Components/service-subject/service-subject-overview/service-subject-overview.component';
import {ViewServiceSubjectComponent} from './back-office/Components/service-subject/view-service-subject/view-service-subject.component';
import {
  ArchiveServiceSubjectComponent
} from './back-office/Components/service-subject/archive-service-subject/archive-service-subject.component';
import {
  ManageServiceSubjectComponent
} from './back-office/Components/service-subject/manage-service-subject/manage-service-subject.component';
import {SolutionOverviewComponent} from './back-office/Components/solution/solution-overview/solution-overview.component';
import {ViewSolutionComponent} from './back-office/Components/solution/view-solution/view-solution.component';
import {SolutionArchiveComponent} from './back-office/Components/solution/solution-archive/solution-archive.component';
import {ManageSolutionComponent} from './back-office/Components/solution/manage-solution/manage-solution.component';
import {DealerViewServiceRequestComponent} from './dealer-system/Components/service/view-service-request/view-service-request.component';
import { ManageExchangeComponent } from './back-office/Components/order/exchange/manage-exchange/manage-exchange.component';
import {
  BackofficeExchangeOverviewComponent
} from './back-office/Components/order/exchange/exchange-overview/backoffice-exchange-overview.component';
import { dealerOrderRequestResolver } from './routing/dealer-order-request.resolve'

export const RouteDefinitions: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
    resolve: {
      'translationLoaded': translationResolver,
    }
  },
  {
    path: 'verify-code',
    component: VerifyCodeComponent,
    resolve: {
      'translationLoaded': translationResolver,
    }
  },
  {
    path: 'forgot-password',
    component: ForgetPasswordComponent,
    resolve: {
      'notLoggedIn': isNotLoggedInResolver,
      'translationLoaded': translationResolver,
    }
  },
  {
    path: 'reset-password/:token',
    component: ResetPasswordComponent,
    resolve: {
      'notLoggedIn': isNotLoggedInResolver,
      'user': resetPasswordResolver,
      'translationLoaded': translationResolver,
    }
  },
  {
    path: 'success-forgot-password',
    component: SuccessForgetPasswordComponent,
    resolve: {
      'notLoggedIn': isNotLoggedInResolver,
      'translationLoaded': translationResolver,
    }
  },
  {
    path: 'login',
    component: LoginComponent,
    resolve: {
      // 'notLoggedIn': isNotLoggedInResolver,
      'translationLoaded': translationResolver,
    }
  },
  {
    path: 'terms/:token',
    component: AcceptTermComponent,
    resolve: {
      'term': acceptTermsResolver,
      'translationLoaded': translationResolver,
    }
  },
  {
    path: 'dealer-system',
    component: AdminComponent,
    resolve: {
      'isLoggedIn': isLoggedInResolver,
      'IsAccessDealer': isAccessDealerResolver,
      'translationLoaded': translationResolver,
    },
    children: [
      {
        path: 'dashboard',
        component: DashboardComponent,
        data: {
          title: 'menu.dashboard.description',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'order/add',
        component: ManageOrderComponent,
        canDeactivate: [canDeactivateGuard],
        canActivate: [tabletUserDataModifierGuard],
        resolve: {
          'onHold': onHoldResolver,
        },
        data: {
          icon: 'icon-layers',
          status: true,
        }
      },
      {
        path: 'order/:id/edit',
        component: ManageOrderComponent,
        canDeactivate: [canDeactivateGuard],
        resolve: {
          'onHold': onHoldResolver,
        },
        data: {
          title: 'menu.place_order.edit.description',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'quote/:id/edit',
        component: ManageOrderComponent,
        canDeactivate: [canDeactivateGuard],
        resolve: {
          'onHold': onHoldResolver,
        },
        data: {
          title: 'menu.place_quote.edit.description',
          icon: 'icon-layers',
          status: true,
          back: '/dealer-system/quote/overview'
        }
      },
      {
        path: 'order/:id/success',
        component: SuccessOrderComponent,
        resolve: {
          'onHold': onHoldResolver,
        },
        data: {
          title: 'menu.place_order.show.description',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'order/:id/show',
        component: ViewOrderComponent,
        resolve: {
          'onHold': onHoldResolver,
        },
        data: {
          title: 'admin.order.order_view',
          icon: 'icon-layers',
          status: true,
          back: '/dealer-system/order/overview'
        }
      },
      {
        path: 'quote/:id/show',
        component: ViewOrderComponent,
        resolve: {
          'onHold': onHoldResolver,
        },
        data: {
          title: 'admin.quote.quote_view',
          icon: 'icon-layers',
          status: true,
          back: '/dealer-system/quote/overview'
        }
      },
      {
        path: 'order/:id/service-request',
        // TODO: Uncomment this if you want enable service request feature
        component: ManageServiceRequestComponent,
        // component: ManageServiceRemarkComponent,
        resolve: {
          'onHold': onHoldResolver,
          // NOTE: please restore this in order to filter route access
          // 'orderData': dealerOrderRequestResolver,
        },
        data: {
          title: 'admin.order.service_request',
          icon: 'icon-layers',
          status: true,
          back: '/dealer-system/order/overview',
        }
      },
      // TODO: Uncomment this if you want enable service request feature
      {
        path: 'service-request/add',
        component: ManageServiceRequestComponent,
        data: {
          title: 'admin.order.service_request',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'order/:id/service-remark',
        component: ManageServiceRemarkComponent,
        data: {
          title: 'admin.order.service_remark',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'exchange',
        component: BackofficeExchangeOverviewComponent,
        data: {
          title: 'menu.exchange',
          icon: 'icon-layers',
          status: true,
        }
      },
      {
        path: 'exchange/:id/edit',
        component: ManageExchangeComponent,
        data: {
          title: 'global.exchange',
          icon: 'icon-layers',
          status: true,
          back: '/dealer-system/exchange'
        }
      },
      {
        path: 'order/exchange/:id/add',
        component: ManageExchangeComponent,
        data: {
          title: 'global.exchange',
          icon: 'icon-layers',
          status: true,
          back: '/dealer-system/order/overview'
        }
      },
      {
        path: 'order/overview',
        component: OrderOverviewComponent,
        resolve: {
          'onHold': onHoldResolver,
        },
        data: {
          title: 'menu.place_order.overview.show.description',
          icon: 'icon-layers',
          status: true
        }
      },
      // TODO: Uncomment this if you want enable service request feature
      {
        path: 'service/overview',
        component: DealerServiceRequestOverviewComponent,
        data: {
          title: 'menu.service.overview.show.description',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'service-request/:id/show',
        component: DealerViewServiceRequestComponent,
        data: {
          title: 'admin.service.request.view.title',
          icon: 'icon-layers',
          status: true,
          back: '/dealer-system/service/overview'
        }
      },
      {
        path: 'quote/overview',
        component: QuoteOverviewComponent,
        data: {
          title: 'menu.place_quote.overview.show.description',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'invoice/overview',
        component: InvoiceComponent,
        data: {
          title: 'menu.invoice.overview',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'download/overview',
        component: DownloadsOverviewComponent,
        resolve: {
          'onHold': onHoldResolver,
        },
        data: {
          title: 'menu.downloads',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'account/overview',
        component: AccountOverviewComponent,
        resolve: {
          'onHold': onHoldResolver,
        },
        data: {
          title: 'menu.my_accounts',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'exchange-logs/overview',
        component: ExchangeLogsOverviewComponent,
        data: {
          title: 'menu.exchanges_logs',
          status: true,
          icon: 'icon-layers',
        }
      },
    ]
  },
  {
    path: 'back-office',
    component: AdminComponent,
    resolve: {
      'isLoggedIn': isLoggedInResolver,
      'isAccessBackOffice': isAccessBackOfficeResolver,
      'translationLoaded': translationResolver,
    },
    children: [
      {
        path: 'dashboard',
        component: DashboardBackOfficeComponent,
        data: {
          title: '',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'exact',
        component: ManageTokenComponent,
        data: {
          title: '',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'collection/overview',
        component: CollectionOverviewComponent,
        data: {
          title: 'menu.collections.overview.description',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'collection/archive',
        component: ArchiveCollectionViewComponent,
        data: {
          title: 'menu.collections.archive.description',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'collection/add',
        component: ManageCollectionComponent,
        data: {
          title: 'menu.collections.add.description',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/collection/overview'
        }
      },
      {
        path: 'collection/:id/show',
        component: ViewCollectionComponent,
        data: {
          title: 'menu.collections.show.description',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/collection/overview'
        }
      },
      {
        path: 'collection/model/:id',
        component: ManageModelComponent,
        data: {
          title: 'menu.collections.models.edit.description',
          icon: 'icon-layers',
          status: true,
          back: 'collection/overview'
        }
      },
      {
        path: 'collection/:id',
        component: ManageCollectionComponent,
        data: {
          title: 'menu.collections.edit.description',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/collection/overview'
        }
      },
      {
        path: 'model/overview',
        component: ModelOverviewComponent,
        data: {
          title: 'menu.collections.models.overview.description',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'model/archive',
        component: ArchiveModelViewComponent,
        data: {
          title: 'menu.collections.models.archive.description',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'model/add',
        component: ManageModelComponent,
        data: {
          title: 'menu.collections.models.add.description',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/model/overview'
        }
      },
      {
        path: 'model/add/:collectionId',
        data: {
          path: 'collection/'
        },
        resolve: {
          'backBreadCrumb': backBreadCrumbResolver
        },
        children: [
          {
            path: '',
            component: ManageModelComponent,
            data: {
              title: 'menu.collections.models.add.description',
              icon: 'icon-layers',
              status: true,
              back: ''
            }
          }],
      },
      {
        path: 'model/:id/show',
        component: ViewModelComponent,
        data: {
          title: 'menu.collections.models.show.description',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/model/overview'
        }
      },
      {
        path: 'model/:id',
        component: ManageModelComponent,
        data: {
          title: 'menu.collections.models.edit.description',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/model/overview'
        }
      },
      {
        path: 'model/:id/:collectionId',
        data: {
          path: 'collection/'
        },
        resolve: {
          'backBreadCrumb': backBreadCrumbResolver
        },
        children: [
          {
            path: '',
            component: ManageModelComponent,
            data: {
              title: 'menu.collections.models.edit.description',
              icon: 'icon-layers',
              status: true,
              back: ''
            }
          }
        ],
      },
      {
        path: 'style/overview',
        component: StyleOverviewComponent,
        data: {
          title: 'menu.collections.styles.overview.description',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'style/archive',
        component: ArchiveStyleViewComponent,
        data: {
          title: 'menu.collections.styles.archive.description',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'style/add',
        component: ManageStyleComponent,
        data: {
          title: 'menu.collections.styles.add.description',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/style/overview'
        }
      },
      {
        path: 'style/:id',
        component: ManageStyleComponent,
        data: {
          title: 'menu.collections.styles.edit.description',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/style/overview'
        }
      },
      {
        path: 'product/overview',
        component: ProductOverviewComponent,
        data: {
          title: 'menu.collections.products.overview.description',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'product/archive',
        component: ArchiveProductViewComponent,
        data: {
          title: 'menu.collections.products.archive.description',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'product/add',
        component: ManageProductComponent,
        data: {
          title: 'menu.collections.products.add.description',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/product/overview'
        }
      },
      {
        path: 'product/stock/overview',
        component: StockProductComponent,
        data: {
          title: 'menu.collections.products.stock.title',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'product/stock/archive',
        component: ArchiveStockProductComponent,
        data: {
          title: 'menu.collections.products.stock.archive.title',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'product/tms-log/overview',
        component: TmsLogComponent,
        data: {
          title: 'menu.collections.products.tms_log.overview',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'product/stock/:id',
        component: ManageProductComponent,
        data: {
          title: 'menu.collections.products.edit.description',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/product/stock/overview'
        }
      },
      {
        path: 'product/add/:modelId',
        data: {
          path: 'model/'
        },
        resolve: {
          'backBreadCrumb': backBreadCrumbResolver
        },
        children: [
          {
            path: '',
            component: ManageProductComponent,
            data: {
              title: 'menu.collections.products.add.description',
              icon: 'icon-layers',
              status: true,
              back: ''
            }
          }
        ],
      },
      {
        path: 'product/:id/show',
        component: ViewProductComponent,
        data: {
          title: 'menu.collections.products.view.description',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/product/overview'
        }
      },
      {
        path: 'product/:id',
        component: ManageProductComponent,
        data: {
          title: 'menu.collections.products.edit.description',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/product/overview'
        }
      },
      {
        path: 'product/:id/:modelId',
        data: {
          path: 'model/'
        },
        resolve: {
          'backBreadCrumb': backBreadCrumbResolver
        },
        children: [
          {
            path: '',
            component: ManageProductComponent,
            data: {
              title: 'menu.collections.products.edit.description',
              icon: 'icon-layers',
              status: true,
              back: ''
            }
          },
        ],
      },
      // fabric collection
      {
        path: 'fabric-collection/overview',
        component: FabricCollectionComponent,
        data: {
          title: 'menu.collections.fabric-collection.overview',
        }
      },
      {
        path: 'fabric-collection/archive',
        component: ArchiveFabricCollectionViewComponent,
        data: {
          title: 'menu.collections.fabric-collection.archive',
        }
      },
      {
        path: 'fabric-collection/add',
        component: ManageFabricCollectionComponent,
        data: {
          title: 'menu.collections.fabric-collection.menu',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/fabric-collection/overview'
        }
      },
      {
        path: 'fabric-collection/:id',
        data: {
          path: 'fabric-collection/',
        },
        resolve: {
          'backBreadCrumb': backBreadCrumbResolver
        },
        children: [
          {
            path: '',
            component: ManageFabricCollectionComponent,
            data: {
              title: 'menu.collections.fabric-collection.edit',
              icon: 'icon-layers',
              status: true,
              back: '/back-office/fabric-collection/overview',
            },
          },
          {
            path: 'edit',
            component: ManageFabricCollectionComponent,
            data: {
              title: 'menu.collections.fabric-collection.edit',
              icon: 'icon-layers',
              status: true,
              back: '',
            },
          },
          {
            path: 'show',
            component: ViewFabricCollectionComponent,
            data: {
              title: 'menu.collections.fabric-collection.show.description',
              icon: 'icon-layers',
              status: true,
              back: '/back-office/fabric-collection/overview'
            },
          },
          {
            path: 'fabric/add',
            component: ManageFabricComponent,
            data: {
              title: 'menu.collections.fabric.add',
              icon: 'icon-layers',
              status: true,
              back: ''
            }
          },
          // fabric
          {
            path: 'fabric/:fabricId',
            component: ManageFabricComponent,
            data: {
              title: 'menu.collections.fabric.edit',
              icon: 'icon-layers',
              status: true,
              back: ''
            },

          },
          {
            path: 'fabric/:fabricId/show',
            component: FabricViewComponent,
            data: {
              title: 'menu.collections.fabric.view.menu',
              icon: 'icon-layers',
              status: true,
              back: ''
            }
          },
          {
            path: 'fabric/add',
            component: ManageFabricComponent,
            data: {
              title: 'menu.collections.fabric.add',
              icon: 'icon-layers',
              status: true,
              back: '/back-office/fabric/'
            }
          },
          {
            path: 'fabric/:fabricId',
            component: ManageFabricComponent,
            data: {
              title: 'menu.collections.fabric.edit',
              icon: 'icon-layers',
              status: true,
              back: '/back-office/fabric/'
            }
          },
        ],
      },
      {
        path: 'property/overview',
        component: PropertyOverviewComponent,
        data: {
          title: 'menu.collections.properties.overview.description',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'property/add',
        component: ManagePropertyComponent,
        data: {
          title: 'menu.collections.properties.add.description',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/property/overview'
        }
      },
      {
        path: 'property/archive',
        component: ArchivePropertyViewComponent,
        data: {
          title: 'menu.collections.properties.archive.description',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'property/:id',
        component: ManagePropertyComponent,
        data: {
          title: 'menu.collections.properties.edit.description',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/property/overview'
        }
      },
      {
        path: 'parts/overview',
        component: PartsOverviewComponent,
        data: {
          title: 'menu.collections.parts.overview.description',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'parts/add',
        component: ManagePartsComponent,
        data: {
          title: 'menu.collections.parts.add.description',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/parts/overview'
        }
      },
      {
        path: 'parts/archive',
        component: ArchivePartsViewComponent,
        data: {
          title: 'menu.collections.parts.archive.description',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'parts/:id',
        component: ManagePartsComponent,
        data: {
          title: 'menu.collections.parts.edit.description',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/parts/overview'
        }
      },
      {
        path: 'supplier/overview',
        component: SupplierOverviewComponent,
        data: {
          title: 'menu.collections.supplier.overview.description',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'supplier/archive',
        component: ArchiveSupplierViewComponent,
        data: {
          title: 'menu.collections.supplier.archive.description',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'supplier/add',
        component: ManageSupplierComponent,
        data: {
          title: 'menu.collections.suppliers.add.description',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/supplier/overview'
        }
      },
      {
        path: 'supplier/:id/show',
        component: ViewSupplierComponent,
        data: {
          title: 'menu.collections.suppliers.show.description',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/supplier/overview'
        }
      },
      {
        path: 'supplier/:id',
        component: ManageSupplierComponent,
        data: {
          title: 'menu.collections.suppliers.edit.description',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/supplier/overview'
        }
      },
      {
        path: 'option/overview',
        component: OptionOverviewComponent,
        data: {
          title: 'menu.collections.option.overview.description',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'option/add',
        component: ManageOptionComponent,
        data: {
          title: 'menu.collections.options.add.description',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/option/overview'
        }
      },
      {
        path: 'option/archive',
        component: ArchiveOptionViewComponent,
        data: {
          title: 'menu.collections.options.archive.description',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'option/:id',
        component: ManageOptionComponent,
        data: {
          title: 'menu.collections.options.edit.description',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/option/overview'
        }
      },
      {
        path: 'option/:id/show',
        component: ViewOptionComponent,
        data: {
          title: 'menu.collections.options.show.description',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/option/overview'
        }
      },
      {
        path: 'system-user/overview',
        component: SystemUsersOverviewComponent,
        canActivate: [superAdminGuard],
        data: {
          title: 'menu.system-users',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'system-user/add',
        component: ManageSystemUsersComponent,
        canActivate: [superAdminGuard],
        data: {
          title: 'menu.system-users.add.description',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/system-user/overview'
        }
      },
      {
        path: 'system-user/:id',
        component: ManageSystemUsersComponent,
        canActivate: [superAdminGuard],
        data: {
          title: 'menu.system-users.edit.description',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/system-user/overview'
        }
      },
      {
        path: 'crm/dealer/overview',
        component: DealerOverviewComponent,
        data: {
          title: 'menu.crm.dealers.overview.description',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'crm/billing-accounts/overview',
        component: BillingAccountsOverviewComponent,
        data: {
          title: 'menu.crm.billing-accounts.overview.description',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'crm/dealer/archive',
        component: ArchiveDealerViewComponent,
        data: {
          title: 'menu.crm.dealers.archive.description',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'crm/dealer/:id',
        data: {
          path: 'crm/dealer/',
        },
        resolve: {
          'backBreadCrumb': backBreadCrumbResolver
        },
        children: [
          {
            path: 'show',
            component: ViewDealerComponent,
            data: {
              title: 'menu.crm.dealers.show.description',
              icon: 'icon-layers',
              status: true,
              back: '/back-office/crm/dealer/overview'
            }
          },
          {
            path: 'delivery/add',
            component: ManageDeliveryDealerComponent,
            data: {
              title: 'menu.crm.dealers.add.description',
              icon: 'icon-layers',
              status: true,
              back: ''
            }
          },
          {
            path: 'delivery/:deliveryId',
            component: ManageDeliveryDealerComponent,
            data: {
              title: 'menu.crm.dealers.delivery.edit.description',
              icon: 'icon-layers',
              status: true,
              back: ''
            }
          },
          {
            path: 'delivery/:deliveryId/show',
            component: ViewDeliveryDealerComponent,
            data: {
              title: 'menu.crm.dealers.show.description',
              icon: 'icon-layers',
              status: true,
              back: ''
            }
          },
        ],
      },
      {
        path: 'crm/billing-account/:id',
        data: {
          path: 'crm/billing-account/',
        },
        resolve: {
          'backBreadCrumb': backBreadCrumbResolver
        },
        children: [
          {
            path: 'show',
            component: ViewBillingAccountComponent,
            data: {
              title: 'menu.crm.billing-accounts.show.description',
              icon: 'icon-layers',
              status: true,
              back: '/back-office/crm/billing-accounts/overview'
            }
          },
        ],
      },
      // TODO: Uncomment this if you want enable service request feature
      {
        path: 'service/request/overview',
        component: ServiceRequestOverviewComponent,
        data: {
          title: 'doctrine.service_request.overview.title',
          icon: 'icon-layers',
          status: true,
        }
      },
      {
        path: 'exact-crm-updates/overview',
        component: ExactCrmUpdatesOverviewComponent,
        data: {
          title: 'doctrine.exact_crm_update.overview',
          icon: 'icon-layers',
          status: true,
        }
      },
      {
        path: 'exact-retries/overview',
        component: ExactRetriesOverviewComponent,
        data: {
          title: 'doctrine.exact_retries.overview',
          icon: 'icon-layers',
          status: true,
        }
      },
      {
        path: 'disclaimer/overview',
        component: DisclaimerOverviewComponent,
        data: {
          title: 'doctrine.disclaimer',
          icon: 'icon-layers',
          status: true,
        }
      },
      {
        path: 'disclaimer/manage',
        component: ManageDisclaimerComponent,
        data: {
          title: 'doctrine.disclaimer',
          icon: 'icon-layers',
          status: true,
        }
      },
      {
        path: 'disclaimer/:id/edit',
        component: ManageDisclaimerComponent,
        data: {
          title: 'doctrine.disclaimer',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/disclaimer/overview'
        }
      },
      {
        path: 'work-form-item/overview',
        component: WorkFormItemOverviewComponent,
        data: {
          title: 'doctrine.work_form_item',
          icon: 'icon-layers',
          status: true,
        }
      },
      {
        path: 'work-form-item/manage',
        component: ManageWorkFormItemComponent,
        data: {
          title: 'doctrine.work_form_item',
          icon: 'icon-layers',
          status: true,
        }
      },
      {
        path: 'work-form-item/:id/edit',
        component: ManageWorkFormItemComponent,
        data: {
          title: 'doctrine.work_form_item',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/work-form-item/overview'
        }
      },
      // TODO: Uncomment this if you want enable service request feature
      {
        path: 'service/request/:id/show',
        component: ViewServiceRequestComponent,
        data: {
          title: 'admin.service.request.view.title',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/service/request/overview'
        }
      },
      {
        path: 'service/request/:id/show/:replyId/archive',
        component: ViewServiceRequestComponent,
        data: {
          path: '/back-office/service/request/',
          title: 'admin.service.request.view.archive_title',
          icon: 'icon-layers',
          status: true,
          back: ''
        },
        resolve: {
          'backBreadCrumb': backBreadCrumbResolver
        }
      },
      {
        path: 'service/request/:requestId/reply/:replyId/order/:id',
        component: ManageOrderComponent,
        canDeactivate: [canDeactivateGuard],
        data: {
          title: 'menu.backoffice.order.view',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/service/request/overview'
        }
      },
      {
        path: 'service/subject/overview',
        component: ServiceSubjectOverviewComponent,
        data: {
          title: 'menu.service.subject.description',
          icon: 'icon-layers',
          status: true,
        }
      },
      {
        path: 'service/subject/:id/show',
        component: ViewServiceSubjectComponent,
        data: {
          title: 'admin.service.subject.view.title',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/service/subject/overview'
        }
      },
      {
        path: 'service/subject/archive',
        component: ArchiveServiceSubjectComponent,
        data: {
          title: 'menu.service.subject.description',
          icon: 'icon-layers',
          status: true,
        }
      },
      {
        path: 'service/subject/add',
        component: ManageServiceSubjectComponent,
        data: {
          title: 'menu.service-subject.add.description',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/service/subject/overview'
        }
      },
      {
        path: 'service/subject/:id/edit',
        component: ManageServiceSubjectComponent,
        data: {
          title: 'menu.service-subject.edit.description',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/service/subject/overview'
        }
      },
      {
        path: 'service/solution/overview',
        component: SolutionOverviewComponent,
        data: {
          title: 'admin.solution.overview.title',
          status: true,
        }
      },
      {
        path: 'service/solution/:id/show',
        component: ViewSolutionComponent,
        data: {
          title: 'global.services',
          status: true,
          back: '/back-office/service/solution/overview'
        }
      },
      {
        path: 'service/solution/archive',
        component: SolutionArchiveComponent,
        data: {
          title: 'admin.solution.archive.title',
          status: true,
        }
      },
      {
        path: 'service/solution/add',
        component: ManageSolutionComponent,
        data: {
          title: 'admin.solution.add.title',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/service/solution/overview'
        }
      },
      {
        path: 'service/solution/add/:subjectId',
        data: {
          path: '/back-office/service/subject/'
        },
        resolve: {
          'backBreadCrumb': backBreadCrumbResolver
        },
        children: [
          {
            path: '',
            component: ManageSolutionComponent,
            data: {
              title: 'admin.solution.add.title',
              icon: 'icon-layers',
              status: true,
              back: ''
            }
          }],
      },
      {
        path: 'service/solution/:id/edit',
        component: ManageSolutionComponent,
        data: {
          title: 'admin.solution.edit.title',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/service/solution/overview'
        }
      },
      {
        path: 'service/solution/:id/edit/:subjectId',
        data: {
          path: '/back-office/service/subject/'
        },
        resolve: {
          'backBreadCrumb': backBreadCrumbResolver
        },
        children: [
          {
            path: '',
            component: ManageSolutionComponent,
            data: {
              title: 'admin.solution.edit.title',
              icon: 'icon-layers',
              status: true,
              back: ''
            }
          }],
      },
      {
        path: 'emails/overview',
        component: EmailOverviewComponent,
        data: {
          title: 'menu.emails.description',
          icon: 'icon-layers',
          status: true,
        }
      },
      {
        path: 'emails/log',
        component: EmailLogComponent,
        data: {
          title: 'menu.emails.log',
          icon: 'icon-layers',
          status: true,
        }
      },
      {
        path: 'download/overview',
        component: DownloadOverviewComponent,
        data: {
          title: 'menu.downloads.overview.description',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'download/add',
        component: ManageDownloadComponent,
        data: {
          title: 'menu.downloads.add.description',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/download/overview'
        }
      },
      {
        path: 'download/:id',
        component: ManageDownloadComponent,
        data: {
          title: 'menu.download.edit.description',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/download/overview'
        }
      },
      {
        path: 'order/:id/service-request',
        // TODO: Uncomment this if you want enable service request feature
        component: ManageServiceRequestComponent,
        // component: ManageServiceRemarkComponent,
        data: {
          title: 'admin.order.service_request',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/order/overview',
        }
      },
      // TODO: Uncomment this if you want enable service request feature
      {
        path: 'order/service-request/add',
        component: ManageServiceRequestComponent,
        data: {
          title: 'admin.order.service_request',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'order/:id/service-remark',
        component: ManageServiceRemarkComponent,
        data: {
          title: 'admin.order.service_remark',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'exchange/:id/edit',
        component: ManageExchangeComponent,
        data: {
          title: 'global.exchange',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/exchange'
        }
      },
      {
        path: 'exchange',
        component: BackofficeExchangeOverviewComponent,
        data: {
          title: 'menu.exchange',
          icon: 'icon-layers',
          status: true,
        }
      },
      {
        path: 'order/exchange/:id/add',
        component: ManageExchangeComponent,
        data: {
          title: 'global.exchange',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/order/overview'
        }
      },
      {
        path: 'order/overview',
        component: BackofficeOrderOverviewComponent,
        data: {
          title: 'menu.backoffice.order.view',
          icon: 'icon-layers',
          status: true,
        }
      },
      {
        // POS insurance chase list (US-606 D5)
        path: 'order/pos/overview',
        component: BackofficePosRegistrationOverviewComponent,
        data: {
          title: 'admin.pos.grid.title',
          icon: 'icon-shield',
          status: true,
        }
      },
      {
        path: 'quote/overview',
        component: BackofficeOverviewQuoteComponent,
        data: {
          title: 'menu.backoffice.quote.view',
          icon: 'fa-th-list',
          status: true,
        }
      },
      {
        path: 'invoice/overview',
        component: BackofficeInvoiceOverviewComponent,
        data: {
          title: 'menu.backoffice.invoice.view',
          icon: 'icon-layers',
          status: true,
        }
      },
      {
        path: 'invoice/draft/overview',
        component: BackofficeDrafyInvoiceOverviewComponent,
        data: {
          title: 'menu.invoice.draft.overview',
          icon: 'icon-layers',
          status: true,
        }
      },
      {
        path: 'invoice/draft/show/:id',
        component: BackofficeDraftInvoiceViewComponent,
        data: {
          title: 'menu.invoice.draft.view',
          icon: 'icon-layers',
          status: true,
        }
      },
      {
        path: 'invoice/draft/show/:id/:logId',
        component: BackofficeDraftInvoiceViewComponent,
        data: {
          title: 'menu.invoice.draft.view',
          icon: 'icon-layers',
          status: true,
        }
      },
      {
        path: 'invoice/draft/logs/overview',
        component: DraftInvoiceLogsOverviewComponent,
        data: {
          title: 'menu.invoice.draft.logs',
          icon: 'icon-layers',
          status: true,
        }
      },
      {
        path: 'packaging-label/overview',
        component: PackagingLabelComponent,
        data: {
          title: 'menu.backoffice.packaging-label.overview',
          icon: 'icon-layers',
          status: true,
        }
      },
      {
        path: 'internal-packaging-label/overview',
        component: InternalPackagingLabelComponent,
        data: {
          title: 'menu.backoffice.internal-packaging-label.overview',
          icon: 'icon-layers',
          status: true,
        }
      },
      {
        path: 'credit-invoice/overview',
        component: CreditInvoiceOverviewComponent,
        data: {
          title: 'menu.credit-invoice.view',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/invoice/overview'
        }
      },
      {
        path: 'order/add',
        component: ManageOrderComponent,
        canDeactivate: [canDeactivateGuard],
        data: {
          title: 'menu.place_order.add.description',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/order/overview'
        }
      },
      {
        path: 'quote/add',
        component: ManageOrderComponent,
        canDeactivate: [canDeactivateGuard],
        data: {
          title: 'menu.place_order.add.description',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/quote/overview'
        }
      },
      {
        path: 'order/:id',
        component: BackofficeViewOrderComponent,
        data: {
          title: 'menu.backoffice.order.view',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/order/overview'
        }
      },
      {
        path: 'quote/:id',
        component: BackofficeViewOrderComponent,
        data: {
          title: 'menu.backoffice.quote.view',
          icon: 'fa-th-list',
          status: true,
          back: '/back-office/quote/overview'
        }
      },
      {
        path: 'order/:id/edit',
        component: ManageOrderComponent,
        canDeactivate: [canDeactivateGuard],
        data: {
          title: 'menu.backoffice.order.view',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/order/overview'
        }
      },

      {
        path: 'quote/:id/edit',
        component: ManageOrderComponent,
        canDeactivate: [canDeactivateGuard],
        resolve: {
          'onHold': onHoldResolver,
        },
        data: {
          title: 'menu.backoffice.quote.view',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/quote/overview'
        }
      },
      {
        path: 'emails/:id',
        component: ManageEmailComponent,
        data: {
          title: 'menu.emails.edit.description',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/emails/overview'
        }
      },
      {
        path: 'localization/overview',
        component: LocalizationOverviewComponent,
        data: {
          title: 'menu.languages.localization.overview.description',
          icon: 'icon-layers',
          status: true,
        }
      },
      {
        path: 'localization/languages',
        component: LanguageListComponent,
        data: {
          title: 'menu.languages.language.overview.description',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'localization/languages/add',
        component: ManageLanguageComponent,
        data: {
          title: 'menu.languages',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'localization/languages/:id',
        component: ManageLanguageComponent,
        data: {
          title: 'menu.languages',
          icon: 'icon-layers',
          status: true,
        }
      },
      {
        path: 'localization/label',
        component: LocalizationLabelComponent,
        data: {
          title: 'menu.languages.localization.label.description',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'country/overview',
        component: CountryOverviewComponent,
        data: {
          title: 'menu.country.overview',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'country/add',
        component: ManageCountryComponent,
        data: {
          title: 'menu.country.add',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/country/overview'
        }
      },
      {
        path: 'country/:id',
        component: ManageCountryComponent,
        data: {
          title: 'menu.country.edit',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/country/overview'
        }
      },
      {
        path: 'terms/overview',
        component: GeneralTermsOverviewComponent,
        data: {
          title: 'menu.terms.overview',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'terms/add',
        component: ManageGeneralTermComponent,
        data: {
          title: 'menu.terms.add',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/terms/overview'
        }
      },
      {
        path: 'terms/:id',
        component: ManageGeneralTermComponent,
        data: {
          title: 'menu.terms.edit',
          icon: 'icon-layers',
          status: true,
          back: '/back-office/terms/overview'
        }
      },
      {
        path: 'dealer-points',
        component: ManageDealerPointsComponent,
        data: {
          title: 'menu.settings.dealer_point',
          status: true,
        }
      },
      {
        path: 'dealer-dashboard/overview',
        component: DealerDashboardOverviewComponent,
        data: {
          title: 'menu.dealer_dashboard_overview',
          status: true,
        }
      },
      {
        path: 'dealer-dashboard/archive',
        component: ArchiveDealerDashboardComponent,
        data: {
          title: 'menu.dealer_dashboard_archive',
          status: true,
        }
      },
      {
        path: 'dealer-dashboard/add',
        component: ManageBlockComponent,
        data: {
          title: 'menu.dealer_add_block',
          status: true,
          icon: 'icon-layers',
          back: '/back-office/dealer-dashboard/overview'
        }
      },
      {
        path: 'dealer-dashboard/:id',
        component: ManageBlockComponent,
        data: {
          title: 'menu.dealer_edit_block',
          status: true,
          icon: 'icon-layers',
          back: '/back-office/dealer-dashboard/overview'
        }
      },
      {
        path: 'invoice-layout/overview',
        component: InvoiceLayoutOverviewComponent,
        data: {
          title: 'doctrine.invoice_layout.overview',
          status: true,
          icon: 'icon-layers',
        }
      },
      {
        path: 'invoice-layout/add',
        component: ManageInvoiceLayoutComponent,
        data: {
          title: 'doctrine.invoice_layout.add',
          status: true,
          icon: 'icon-layers',
          back: '/back-office/invoice-layout/overview'
        }
      },
      {
        path: 'invoice-layout/:id',
        component: ManageInvoiceLayoutComponent,
        data: {
          title: 'doctrine.invoice_layout.edit',
          status: true,
          icon: 'icon-layers',
          back: '/back-office/invoice-layout/overview'
        }
      },
      {
        path: 'dealer-profile/overview',
        component: DealerProfileOverviewComponent,
        data: {
          title: 'doctrine.dealer_profile.overview',
          status: true,
          icon: 'icon-layers',
        }
      },
      {
        path: 'dealer-profile/add',
        component: ManageDealerProfileComponent,
        data: {
          title: 'doctrine.dealer_profile.add',
          status: true,
          icon: 'icon-layers',
          back: '/back-office/dealer-profile/overview'
        }
      },
      {
        path: 'dealer-profile/:id',
        component: ManageDealerProfileComponent,
        data: {
          title: 'doctrine.dealer_profile.edit',
          status: true,
          icon: 'icon-layers',
          back: '/back-office/dealer-profile/overview'
        }
      },
      {
        path: 'exact-logs/overview',
        component: ExactLogsOverviewComponent,
        data: {
          title: 'doctrine.exact_log.overview',
          status: true,
          icon: 'icon-layers',
        }
      },
      {
        path: 'exchange-logs/overview',
        component: ExchangeLogsOverviewComponent,
        data: {
          title: 'menu.exchanges_logs',
          status: true,
          icon: 'icon-layers',
        }
      },
      {
        path: 'export',
        component: ExportComponent,
        data: {
          title: 'menu.exports',
          icon: 'icon-layers',
          status: true
        }
      },
      {
        path: 'account-setting',
        component: AccountSettingComponent,
        canActivate: [backofficeGuard],
        data: {
          title: 'menu.account_setting_title',
          icon: 'icon-layers',
          status: true
        }
      }
    ]
  },
  {
    path: 'exact/success',
    component: ManageTokenComponent,
    resolve: {
      'isLoggedIn': isLoggedInResolver,
      'isAccessBackOffice': isAccessBackOfficeResolver,
      'translationLoaded': translationResolver,
    },
  }
];

@NgModule({
  imports: [RouterModule.forRoot(RouteDefinitions, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
